module.exports = __webpack_public_path__ + "static/img/dn_logo.687d838.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dn_logo.png
// module id = sd2l
// module chunks = 13